import { Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';
import { ModalContextProvider } from '~settings/components/Modal';
import { CreateSublabelFromRequestPage } from '~settings/modules/sublabel-request/pages/CreateLabelFromRequestPage';

import { RequestSublabelPage } from './pages/RequestSublabelPage';

export function SublabelRequestRouter() {
  return (
    <Routes>
      <>
        <Route
          path="create"
          element={
            <ModalContextProvider>
              <RequestSublabelPage />
            </ModalContextProvider>
          }
        />
        <Route path="edit" element={<CreateSublabelFromRequestPage />} />
      </>

      <Route path="*" element={<ErrorPage type="notFoundPage" />} />
    </Routes>
  );
}
SublabelRequestRouter.displayName = 'SublabelRequestRouter';
